<template>
  <div class="cookie-bar">
    <div class="cookie-bar__description">
      <BaseTitle
      :tag="'h4'">
      {{$t('message.common.cookieBar.title')}}
      </BaseTitle>

      <div class="description">
      {{$t('message.common.cookieBar.description')}}
      </div>

    </div>
    <div class="cookie-bar__action">
       <BaseTitle
       :tag="'h4'">
      {{$t('message.common.cookieBar.label')}}

      </BaseTitle>

      <BaseButton @click.native="handleClick">
      {{$t('message.common.buttons.cookieConsent')}}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { createCookie } from '@modules/cookies'
import BaseTitle from '@base/BaseTitle'
import BaseButton from '@base/BaseButton'
export default {
  name: 'CookieBar',
  components: {
    BaseTitle,
    BaseButton
  },
  methods: {
    handleClick () {
      createCookie('cookie-consent', true)
      this.$emit('cookieconsent')
    }
  }

}
</script>

<style lang="scss">
  .cookie-bar {
    @include media ('small-medium') {
      flex-direction: column;
      padding-right: 1rem;
      .button {
        width: 100%;
      }

    }
    width: 100%;
    display: flex;
    position: fixed;
    bottom: 0;
    padding-left: 1rem;
    font-size: 1.5rem;
    color: white;
    background-color: colors(border-dark);
    z-index: 1000;
    > * {
      flex: 0 1 auto;
      padding: 1rem;
    }
    .title {
      margin-bottom: 0.5em;
    }

    .button {
      background-color: colors(primary);
      color: white;

      &:hover {
        background-color: shade(colors(primary), 15%);
      }
    }

    &__description {
      .description {
        font-size: 1.3rem;
      }
    }

  }

</style>
